import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { accountService } from "./../_services";
import { Login } from "./Login";
import { Register } from "./Register";
import { VerifyEmail } from "./VerifyEmail";
import { ForgotPassword } from "./ForgotPassword";
import { ResetPassword } from "./ResetPassword";
import { util, config } from "../_helpers";

// Import background images
import bg1 from "../assets/bg1.png";
import bg2 from "../assets/bg2.png";
import bg3 from "../assets/bg3.png";
import bg4 from "../assets/bg4.png";
import bg5 from "../assets/bg5.png";
import bg6 from "../assets/bg6.png";
import bg7 from "../assets/bg7.png";
import bg8 from "../assets/bg8.png";
import bg9 from "../assets/bg9.png";

function Account({ history, match }) {
  const { path } = match;
  const { search } = useLocation();

  useEffect(() => {
    // redirect to home if already logged in
  }, []);

  const verticals = ["Restaurants", "Retails", "Schools", "Hospitals", "Salons", "Gym", "Healthcare"];
  const products = ["Digital Signage", "PoS", "Self Order System", "Table Top Orders", "Online Order", "Drive App", "Token System"];

  return (
    <div className="auth-wrapper">
      <div className="netflix-background">
        <div className="netflix-overlay"></div>
        <div className="netflix-grid">
          {/* Row 1: Images (Moving Right) */}
          <div className="netflix-row right">
            <div className="netflix-item" style={{backgroundImage: `url(${bg1})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg2})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg3})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg9})`}}></div> {/* Token System Image */}
            <div className="netflix-item" style={{backgroundImage: `url(${bg5})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg1})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg2})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg3})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg9})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg5})`}}></div>
          </div>
          
          {/* Row 2: Verticals Strip (Moving Left) */}
          <div className="netflix-row left">
            {verticals.map((v, i) => (
              <div key={i} className="netflix-item text-item vertical"><span>{v}</span></div>
            ))}
            {verticals.map((v, i) => (
              <div key={`dup-${i}`} className="netflix-item text-item vertical"><span>{v}</span></div>
            ))}
          </div>
          
          {/* Row 3: Products Strip (Moving Right) */}
          <div className="netflix-row right">
            {products.map((p, i) => (
              <div key={i} className="netflix-item text-item product"><span>{p}</span></div>
            ))}
            {products.map((p, i) => (
              <div key={`dup-${i}`} className="netflix-item text-item product"><span>{p}</span></div>
            ))}
          </div>

          {/* Row 4: Images (Moving Left) */}
          <div className="netflix-row left">
            <div className="netflix-item" style={{backgroundImage: `url(${bg6})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg7})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg8})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg9})`}}></div> {/* Token System Image */}
            <div className="netflix-item" style={{backgroundImage: `url(${bg2})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg6})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg7})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg8})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg9})`}}></div>
            <div className="netflix-item" style={{backgroundImage: `url(${bg2})`}}></div>
          </div>
        </div>
      </div>
      
      <div className="centered-card">
        <div className="auth-logo-container">
          <div className="logo-box">
             <img src={config.Black_Theme_Logo} alt="Logo" />
          </div>
        </div>
        
        <Switch>
          <Route path={`${path}/login`} component={Login} />
          <Route path={`${path}/register`} component={Register} />
          <Route path={`${path}/verify-email`} component={VerifyEmail} />
          <Route path={`${path}/forgot-password`} component={ForgotPassword} />
          <Route path={`${path}/reset-password`} component={ResetPassword} />
        </Switch>
      </div>
    </div>
  );
}

export { Account };
